<!-- <div *ngIf="spinner==true">
  <ngx-spinner  size="medium"  type="timer" >
      <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
  </ngx-spinner>
</div> -->
<div class="hold-transition login-page">
  <div class="login-box">
      
      <!-- /.login-logo -->
      <div class="card">
        <div class="login-logo">
          <a class="title">Welcome to <b>MyRoots</b> Portal</a>
          <div>
           <img src="assets/dmk.png" alt="Logo" class="" style="opacity: .8;width: 150px;">
          </div>
        </div>
        <p style="font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;color: #015792;margin-bottom: unset;
        margin-left: 8%;">Existing User's Login</p>
        
        <div class="card-body login-card-body">
          <form [formGroup]="userForm" (ngSubmit)="postdata(userForm)">
            <!-- <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Enter your Registered Mobile Number" formControlName="whatsapp_no"  [minlength]="10" [maxlength]="15"  (keyup)="getlogincheck(userForm.get('whatsapp_no').value)"/>
              
              <div class="input-group-append">
                <div class="input-group-text">
                  <i class="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
                    </svg>
                  </i>
                  
                </div>
              </div>       
                    
            </div>
            
            <div  class="invalid-msg" *ngIf="test_ph=='true' && userForm.get('whatsapp_no').value !=''&& userForm.get('whatsapp_no').hasError('pattern') && userForm.get('whatsapp_no').touched" >User name is incorrect </div>    
            <div *ngIf="test_ph=='true' && userForm.get('whatsapp_no').status=='VALID'&& userForm.get('whatsapp_no').touched==true && userForm.get('whatsapp_no').value!=''" class="invalid-msg">
              Username is incorrect</div>
              <div *ngIf="test_ph=='true' && userForm.get('whatsapp_no').status=='INVALID'&& userForm.get('whatsapp_no').touched==true && userForm.get('whatsapp_no').value!=''" class="invalid-msg">
                Username is incorrect</div>  -->


                <div class="input-group mb-3">
                  <input
                  type="text"
                  class="form-control"
                  placeholder="Enter your Registered Mobile Number"
                  formControlName="whatsapp_no"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  minlength="10"
                  maxlength="15"
                  (input)="onInputNumber($event)"
                  (keyup)="getlogincheck(userForm.get('whatsapp_no').value)"
                />
                
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <i class="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"
                          />
                        </svg>
                      </i>
                    </div>
                  </div>
                </div>
                
                <!-- Error for less than 10 digits -->
                <div
                  class="invalid-msg"
                  *ngIf="
                    userForm.get('whatsapp_no').touched &&
                    userForm.get('whatsapp_no').value.length < 10 &&
                    userForm.get('whatsapp_no').value != ''
                  "
                >
                  Mobile number must be at least 10 digits.
                </div>
                
                <!-- Error for invalid number (not found in DB) -->
                <div
                  class="invalid-msg"
                  *ngIf="
                    test_ph == 'true' &&
                    userForm.get('whatsapp_no').touched &&
                    userForm.get('whatsapp_no').status == 'VALID' &&
                    userForm.get('whatsapp_no').value != ''
                  "
                >
                  Mobile number is incorrect.
                </div>
                
            <!-- <div class="input-group mb-3">
              <input type="password" class="form-control" placeholder="Password"  formControlName="password">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div> -->

            <div class="input-group mb-3">
              <input #passwordInput type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" formControlName="password" placeholder="Password">
              
                <!-- <button  type="button" (click)="togglePasswordVisibility()" style="border:none;">
                  <span [ngClass]="{'fa': true, 'fa-eye-slash': hidePassword, 'fa-eye': !hidePassword}"></span>
                </button> -->
                <div class="input-group-append" >
                  <div class="input-group-text">

                  <div (click)="togglePasswordVisibility()">
                          <img src="assets/eye.jpg" alt="Example Image" style="height:9px">
                        
                      </div>
                      </div>
            </div>

            </div>
            
            

            
            <!-- <div *ngIf=" userForm.get('password').status=='VALID'&& userForm.get('password').touched==true && userForm.get('password').value !=''" class="invalid-msg">
               please enter password</div>
               <div *ngIf=" userForm.get('password').status=='INVALID'&& userForm.get('password').touched==true && userForm.get('password').value !=''" class="invalid-msg">
                please enter password</div> -->
            <div class="row">
              <!-- <div class="col-8">
                <div class="icheck-primary">
                  <input type="checkbox" id="remember">
                  <label for="remember">
                    Remember Me
                  </label>
                </div>
              </div> -->
              <!-- /.col -->
              <div>
                <!-- <a href="#" class="btn btn-block btn-primary">
                  <i class="fab fa-facebook mr-2"></i> Sign In
                </a>
                <button type="submit" [routerLink]="['superadmin']" class="btn btn-primary btn-block"></button> -->
              </div>
              <!-- /.col -->
            </div>
            <div class="form-group row" style="border:none ; border-radius: 10px;height:offsetHeight;padding:10px 5px;">
              <label>CAPTCHA<span class="required"> *</span></label>

                <re-captcha
                class="g-recaptcha"
                  siteKey="6LfgWy4qAAAAAFA_fFnEtWlW0TnhfH0p73y86j_5"
                  (resolved)="onCaptchaResolved($event)">
                  >
                </re-captcha>
                <!-- <re-captcha
                class="g-recaptcha"
                  siteKey="6LfUyTwqAAAAAJMGRDb38ec7oLRj_gjRUPNF_8eI"
                  (resolved)="onCaptchaResolved($event)">
                </re-captcha> -->
                <div style="color:red;" *ngIf="captchaError">Please complete the CAPTCHA</div>
            </div>
            <button class="btn btn-block btn-primary1" [disabled]="isFormDisabled()">Sign in</button>
            <!-- <div *ngIf="btnDisable==true">
              Your three attempt is completed. Your account was blocked 
            </div> -->
  
          </form>
    
          <div class="social-auth-links text-center mb-3">
            <!-- <p>- OR -</p> -->
            <!-- <a [routerLink]="['superadmin']" class="btn btn-block btn-primary">
              <i ></i> Sign in 
            </a> -->
            <!-- <a href="#" class="btn btn-block btn-danger">
              <i class="fab fa-google-plus mr-2"></i> Sign in using Google+
            </a> -->
          </div>
          <!-- /.social-auth-links -->
    
          <p class="mb-1 text-center  ">
            <a [routerLink]="['forgot_password']" class="newcolor1" >Forgot password</a>
          </p>
            <p class="mb-1 text-center ">
              <a [routerLink]="['students']" class="newcolor1">New Student Self Registration</a>
            </p>
              <p class="mb-1 text-center ">
                <a [routerLink]="['mentor']" class="newcolor1">New Mentor Self Registration</a>
              </p>
          <p class="mb-0 text-center">
            <!-- <a [routerLink]="['self-registration']" class="text-center">Self-Registration</a> -->
          </p>
        </div>
        
        <!-- /.login-card-body -->
      </div>
      <div class="footer" style="background-color: #e9ecef !important;">
        <div class="text-center p-3">
          <p>Copyright © MyRoots. Developed by <a target="_blank">RedMind Technologies</a> {{footerdate}}</p>
        </div>
        <div>
          <p style="font-family: Arial, sans-serif; font-size: 10px; font-weight: bold;color: #015792;text-align: center;">Version 2.0</p>
        </div>
      </div>
    </div>
  </div>
 